module.exports = __webpack_public_path__ + "static/media/retorno-santo-antonio.570878a0.webp";